import { onMounted, onUnmounted, ref, toRefs, reactive } from "vue"

export default function useMousePosition() {

    // 定义鼠标坐标的变量
    const state = reactive({
        mouseX: 0,
        mouseY: 0
    })

    let { mouseX, mouseY } = toRefs(state)

    // 鼠标移动重新赋值
    const onmousemove = (e) => {
        console.log(e);
        mouseX.value = e.pageX
        mouseY.value = e.pageY

    }

    onMounted(() => {
        document.addEventListener("mousemove", (e) => {

            onmousemove(e)
        })
    })

    onUnmounted(() => {
        document.removeEventListener("mousemove")
    })

    return {
        mouseX,
        mouseY
    }
}